import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

export const MAIN_CONTENT_ID = "main-content";

export function SkipToMainContent() {
  const { t } = useTranslation();

  return (
    <a href={`#${MAIN_CONTENT_ID}`} className={styles.link}>
      {t("Skip to main content")}
    </a>
  );
}

const styles = {
  link: css({
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0,
    "&:focus": {
      position: "fixed",
      top: "var(--space-4)",
      left: "var(--space-4)",
      zIndex: 200,
      width: "auto",
      height: "auto",
      margin: 0,
      padding: "var(--space-2) var(--space-4)",
      overflow: "visible",
      clip: "auto",
      background: "var(--background-base)",
      color: "var(--text-base)",
      borderRadius: "var(--border-radius-2)",
      boxShadow: "var(--focus-action)",
      textDecoration: "none",
    },
  }),
};
